import React from "react";
import { Typography, Button } from "@mui/material";
import { ReactComponent as Celebration } from "../../../assets/img/celebration.svg";
import Page from "components/ui/Page/Page";
import { FormContainer } from "components/ui/FormField/FormFieldContainer";

/**
 * @description This component renders the "Eligibility Success" step of the enrollment process.
 * @param {Function} onSubmit - The function to handle form submission.
 * @returns {JSX.Element} The rendered component.
 */
const EligibilitySuccess = ({ onSubmit }) => {
    return (
        <Page
            heading="You're Eligible!"
            subHeading="Let's do a quick health check. This helps us get you into the right program."
        >
            <FormContainer
                sx={{
                    textAlign: "center",
                    width: "65%",
                }}
            >
                <Typography variant="h3" sx={{ color: "#0f172a" }}>
                    <Celebration />
                </Typography>
                <Button variant="contained" onClick={onSubmit}>
                    Start
                </Button>
            </FormContainer>
        </Page>
    );
};

export default EligibilitySuccess;
